import CluserHeadList from '../../features/admin/CluserHeadList'

const CluserHeadListPage = () => {
  return <CluserHeadList/>
}

export default CluserHeadListPage